//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import directHeading from "~/components/content/direct/directHeading.vue";
import directSection from "~/components/content/direct/directSection.vue";
import directActionsBlock from "~/components/content/direct/directActionsBlock.vue";
import directFaqItem from "~/components/content/direct/directFaqItem.vue";

export default {
  name: "directSectionFaq",
  components: {
    directHeading,
    directSection,
    directActionsBlock,
    directFaqItem,
  },
  data() {
    return {
      faqList: [
      {
        title: "Wat is Meiden van Holland Direct?",
        content:
        "Meiden van Holland Direct is het nieuwe all-inclusive online abonnement om onbeperkt sexfilms mee te kijken. Onbezorgd, geil en snel je favoriete sexfilms waar je ook bent. Kom elke dag aan je trekken voor een vaste lage prijs per maand en geniet ondertussen van alle extra voordelen, exclusief en alleen met een Direct abonnement. Altijd oer-Hollandse amateursex binnen handbereik, zorgeloos geilen start met Meiden van Holland Direct.",
      },
      {
        title: "Welke sexfilms krijg ik?",
        content:
        "Alle geile sexfilms herkenbaar aan het “Direct” label liggen voor het grijpen (vroeger abonnement). Elke maand komen daar altijd nieuwe Nederlandse sex scenes bij. Start nu en geniet altijd van onze natte meiden!",
      },
      {
        title: "Welke extra's krijg ik met Direct?",
        content:
        "Als “Direct” lid word je extra verwend door onze meiden. Doe mee aan exclusieve sexy winacties, maak kans op geile prijzen en meer. Alleen voor leden!",
      },
      {
        title: "Wat kost Meiden van Holland Direct?",
        content:
        "Meiden van Holland Direct kost standaard 6,99 per maand. Als introductie bieden wij de eerste 3 maanden voor 17,50 aan. Dat is een lekkere binnenkomer met 17% korting.",
      },
      {
        title: "Kan ik opzeggen wanneer ik wil?",
        content:
        "Weglopen van alle potjes geile sex? Als je dat echt wilt kan dit altijd en regel je dat vanaf jouw account met één druk op de knop.",
      },
      ],
      faqActiveIndex: -1,
      faq: "",
    };
  },
  methods: {
    toggleQuestion(index) {
      this.faqActiveIndex = this.faqActiveIndex === index ? -1 : index;
    },
  },
};
